import { defineComponent as _defineComponent } from 'vue'
import { computed } from '@nuxtjs/composition-api';
import {
  forEachSections,
  sectionsWithDataProps,
} from '@webplatform/asbis-ui/dist/sections';
import type { Block, CatalogBlock } from '~/types';
import { prepareDynamicBlock, kebabToPascal } from '~/helpers';
import FormSectionPartnership from '~/components/sections/FormSection/FormSectionPartnership.vue';
import FormSectionConsultation from '~/components/sections/FormSection/FormSectionConsultation.vue';
import AppleCalculator from '~/components/AppleCalculator.vue';
import BannersSlider from '~/domains/sliders/components/BannersSlider';
import SolutionsCarousel from '~/domains/sliders/components/SolutionsCarousel';
import CategoryBanner from '~/domains/categories/components/CategoryBanner';
import CategoryFeatures from '~/domains/categories/components/CategoryFeatures';
import CategoryProductSeries from '~/domains/categories/components/CategoryProductSeries';
import CategoryAccessories from '~/domains/categories/components/CategoryAccessories';
import CategoryFaq from '~/domains/categories/components/CategoryFaq';
import HtmlContentBlock from '~/components/HtmlContentBlock';
import SoftwareCategoryTryDemo from '~/domains/categories/components/SoftwareCategoryTryDemo';
import SoftwareCategoryChoosePlan from '~/domains/categories/components/SoftwareCategoryChoosePlan';

interface Props {
  blocks?: (Block | CatalogBlock)[];
}

export default /*#__PURE__*/_defineComponent({
  __name: 'PageBlocks',
  props: {
    blocks: { default: () => [] }
  },
  setup(__props: any) {

const props = __props as { blocks: (Block | CatalogBlock)[] };

const COMPONENTS_ALIASES = {
  'ui-carousel': 'feature-section-carousel',
  'ui-text-image': 'feature-section-text-image',
  'ui-video-list': 'video-section-simple',
  'ui-card-list': 'feature-section-articles',
  'categories-section': 'card-section-grid',
  'cards-section-grid': 'card-section-grid',
  'category-applications': 'card-section-apps',
  'cards-section-flags': 'card-section-flags',
  'category-info-blocks': 'feature-section-info-blocks',
  'category-recommended': 'feature-section-recommended',
  'software-category-awards': 'card-section-awards',
  'software-category-first-screen': 'feature-section-columns',
  'software-category-infoblocks': 'feature-section-simple-list',
  'software-category-reviews-slider': 'testimonial-section-slider',
  'software-category-user-help': 'document-section-simple',
  'cards-section-simple': 'card-section-simple',
  'latest-news': 'blog-section-simple',
  'catalog-header': 'header-section-image',
  'consultation-form': 'form-section-consultation',
  'partnership-form': 'form-section-partnership',
};

const EXCLUDED_BLOCKS = ['page-info', 'short_description'];

const localSections = {
  AppleCalculator,
  BannersSlider,
  SolutionsCarousel,
  CategoryBanner,
  CategoryFeatures,
  CategoryProductSeries,
  CategoryAccessories,
  CategoryFaq,
  HtmlContentBlock,
  SoftwareCategoryTryDemo,
  SoftwareCategoryChoosePlan,
  FormSectionPartnership,
  FormSectionConsultation,
};
const asbisUiSections: Record<string, any> = {};

forEachSections((sectionName, sectionComponent) => {
  if (!Object.keys(localSections).includes(sectionName))
    asbisUiSections[sectionName] = sectionComponent;
});

const sectionComponents = {
  ...localSections,
  ...asbisUiSections,
};


const components = computed(() =>
  props.blocks?.map((block) =>
    prepareDynamicBlock(block, {
      excludedBlocks: EXCLUDED_BLOCKS,
      aliases: COMPONENTS_ALIASES,
      sectionsWithDataProps,
    }),
  ),
);

const getComponentToRender = (componentType?: string) =>
  componentType
    ? (sectionComponents as Record<string, any>)[kebabToPascal(componentType)]
    : undefined;

const getBindingData = (component: ReturnType<typeof prepareDynamicBlock>) => {
  const isEmptyComponent = !('type' in component && 'data' in component);
  if (isEmptyComponent) return {};
  if (component.type === 'html-content-block')
    return { content: component.data };
  return component.data;
};

return { __sfc: true,COMPONENTS_ALIASES, EXCLUDED_BLOCKS, localSections, asbisUiSections, sectionComponents, props, components, getComponentToRender, getBindingData }
}

})